import {useContext, useEffect, useState} from "react";
import LanguageContext from "../context/language";

export const useContent = (content) => {
    const [displayedContent, setDisplayedContent ] = useState({});

    const { language } = useContext(LanguageContext);

    useEffect(() => {
        setDisplayedContent(content[language]);
    }, [language, content]);

    return displayedContent;
};
